    import React from "react";

const FormNumberInput = ({
    field,
    value = 0,
    handleChange,
    error = null,
    className = "",
}) => {
    const min = field.min ?? 0;
    const max = field.max ?? Infinity;
    const step = field.step ?? 1;

    const isDisabled = field.disabled || field.readOnly;

    const updateValue = (newValue) => {
        if (isDisabled) return;
        if (newValue < min || newValue > max) return;

        handleChange({
            target: {
                name: field.name,
                value: newValue,
            },
        });
    };

    return (
        <div  className={`${className} ${field.fieldSize || "col-12"}`}>
            {field.label && (
                <label className="form-label text-muted">
                    {field.label}
                    {field.required && <span className="text-danger small">*</span>}
                </label>
            )}

            {/* WRAPPER */}
            <div
                className={`form-control d-flex align-items-center p-0 ${error ? "border-danger" : ""
                    } ${isDisabled ? "number-input-disabled" : ""}`}
                style={{ height: "38px" }}
            >
                {/* Decrement */}
                <button
                    type="button"
                    className="border-0 bg-transparent h-100 px-3"
                    onClick={() => updateValue(Number(value) - step)}
                    disabled={isDisabled || value <= min}
                    style={{
                        color: isDisabled ? "#6c757d" : "#212529",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                    }}
                >
                    −
                </button>

                {/* Input */}
                <input

                    type="number"
                    className="form-control border-0 text-center shadow-none h-100"
                    name={field.name}
                    value={value}
                    onChange={(e) => updateValue(Number(e.target.value))}
                    min={min}
                    max={max}
                    step={step}
                    disabled={isDisabled}
                    readOnly={isDisabled}
                    placeholder ={field.placeholder}
                    style={{
                        backgroundColor: "transparent",
                        color: isDisabled ? "#6c757d" : "#212529",
                        cursor: isDisabled ? "not-allowed" : "text",
                    }}
                />

                {/* Increment */}
                <button
                    type="button"
                    className="border-0 bg-transparent h-100 px-3"
                    onClick={() => updateValue(Number(value) + step)}
                    disabled={isDisabled || value >= max}
                    style={{
                        color: isDisabled ? "#6c757d" : "#212529",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                    }}
                >
                    +
                </button>
            </div>

            {error && <span className="text-danger small">{error}</span>}
        </div>
    );
};

export default FormNumberInput;
